<!-- 用于弹出层刻度尺组件 -->
<template>
  <van-popup v-model="show" round position="bottom" @closed="bindClose">
    <div class="container" v-if="show">
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="title"
        ><span>选择你的目标体重</span
        ><img
          class="icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/607461d1dd65d111be55e95d14885628.png"
          alt=""
      /></div>
      <div class="desc">当前体重：{{ weight }}kg</div>
      <div class="content">
        <div class="value">
          <div>
            <span class="number">{{ curNum }}</span>
            <span class="unit">KG</span>
          </div>
        </div>
        <MyRuler
          style="margin-bottom: 48px"
          @change="bindRulerNum"
          :NowNum="defaultNum"
          :maxNum="maxNum"
          theme="#81EF5F"
          :minNum="minNum"
        />
        <div class="btn-content">
          <div class="btn-item confirm" @click="bindConfirm">选好了</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import MyRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    MyRuler
  },
  props: {
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    },
    weight: {
      type: Number,
      default: 0
    },
    target_weight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      maxNum: 200,
      minNum: 30,
      defaultNum: 60,
      show: false,
      curNum: 0
    }
  },
  watch: {
    value() {
      this.show = this.value
    },
    weight() {
      this.defaultNum = this.target_weight || this.weight || 60
    },
    target_weight() {
      this.defaultNum = this.target_weight || this.weight || 60
    }
  },
  computed: {},
  created() {
    this.show = this.value
    this.defaultNum = this.target_weight || this.weight || 60
  },
  mounted() {},
  methods: {
    bindRulerNum(value) {
      this.curNum = value
    },
    bindClose() {
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm', this.curNum)
      this.bindClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup--round {
  border-radius: 8px 8px 0px 0px;
}

.container {
  background: #ffffff
    linear-gradient(187deg, #ebfedf 0px, rgba(255, 255, 255, 0) 100px);
  border-radius: 16px 16px 0px 0px;
  padding: 20px 20px 56px;
  position: relative;

  .close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .title {
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      margin-left: 3px;
      width: 15px;
      height: 18px;
    }
  }

  .desc {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 35px;
  }

  .content {
    text-align: center;

    .value {
      margin: 0 auto 20px;
      width: 229px;
      height: 106px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/db76e8d767e35413c6108de2b49e508b.png');
      background-repeat: no-repeat;
      background-size: contain;
      .number {
        text-align: right;
        min-width: 60px;
        white-space: nowrap;
        display: inline-block;
        font-size: 30px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 30px;
      }

      .unit {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 16px;
      }
    }
  }
}

.btn-content {
  padding: 0px 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-item {
    text-align: center;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #0d0d0d;
    border-radius: 21px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
